import { Trans } from "@lingui/macro";
import { UiBox, UiSwitch, UiTypography } from "@smp/ui";
import { FC } from "react";

import { IInvoiceFormValues } from "../../use_invoice_form";

export interface IPaymentTypeSelectorProps {
  value: IInvoiceFormValues["paymentType"];
  onChange: (
    value: Exclude<IInvoiceFormValues["paymentType"], undefined>,
  ) => void;
}

export const PaymentTypeSelector: FC<IPaymentTypeSelectorProps> = ({
  value,
  onChange,
}) => (
  <>
    <UiBox mb={2}>
      <UiTypography variant="h4">
        <Trans>Plan subscription</Trans>
      </UiTypography>
    </UiBox>
    <UiBox>
      <UiSwitch
        checked={value === "recurring"}
        label={<Trans>Recurring Payment</Trans>}
        onClick={() => onChange(value === "recurring" ? "single" : "recurring")}
      />
    </UiBox>
  </>
);
